<template>
  <div class="flow-configure-data-design-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等..."
       :style="themeVars">
    <div class="menubar">
      <el-button size="mini"
                 type="primary"
                 icon="el-icon-s-promotion"
                 round
                 @click="publish">校验发布</el-button>
    </div>
    <div class="design-wrap">
      <div class="header">
        <div class="title theme-text">
          <i class="el-icon-menu"></i>
          <span>{{designInfo.name}}</span>
          <template v-if="designInfo.version">
            <el-tag size="mini">第 {{designInfo.version}} 版</el-tag>
          </template>
        </div>
        <el-radio-group v-model="activeSelect">
          <el-radio-button label="processDesign">① 审批流程</el-radio-button>
          <el-radio-button label="advancedSetting">② 更多设置</el-radio-button>
        </el-radio-group>
      </div>
      <div class="body">
        <div class="body-cont">
          <el-tabs v-model="activeSelect"
                   class="design-tabs">
            <el-tab-pane name="processDesign"
                         label="① 审批流程 ">
              <ProcessDesign ref="processDesign"
                             @selectedNode="nodeSelected"></ProcessDesign>
            </el-tab-pane>
            <el-tab-pane name="advancedSetting"
                         label="② 更多设置 ">
              <AdvancedSetting ref="advancedSetting"></AdvancedSetting>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <DataGridDialog :visible.sync="validVisible"
                    title="设置项检查"
                    width="500px">
      <div class="flow-configure-data-design-main-valid">
        <div class="steps">
          <el-steps align-center :active="validStep" finish-status="success">
            <el-step v-for="(step, i) in validOptions" :title="step.title" :key="i"
                     :icon="step.icon" :status="step.status" :description="step.description"/>
          </el-steps>
        </div>
        <div class="result-wrap">
          <div class="icon">
            <i :class="validIcon"></i>
          </div>
          <div class="err-info" v-if="validResult.errs.length > 0">
            <ellipsis hover-tip v-for="(err, i) in validResult.errs" :key="i + '_err'" :content="err">
              <i slot="pre" class="el-icon-warning-outline"></i>
            </ellipsis>
          </div>
          <div class="result">
            <div v-if="errTitle" class="title">{{errTitle}}</div>
          </div>
          <div class="footer">
            <el-button type="primary" v-if="validResult.finished" size="medium" @click="doAfter" :loading="committing">
              {{ committing ? '发布中...' : validResult.action }}
            </el-button>
          </div>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../elements/grid/DataGridDialog'
import ProcessDesign from '../../../../elements/flow/layout/ProcessDesign'
import AdvancedSetting from '../../../../elements/flow/layout/AdvancedSetting'
import Theme from '../../../../../mixins/theme'
export default {
  name: 'FlowConfigureDataDesignMain',
  mixins: [Theme],
  components: {
    DataGridDialog,
    ProcessDesign,
    AdvancedSetting
  },
  props: {
    flowId: {
      type: String,
      required: true
    },
    flowKey: String,
    designInfo: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  provide () {
    return {
      $workflow: this.state,
      $workflowKey: this.flowKey
    }
  },
  data () {
    let design = {
      setting: {
        sign: false,
        actions: {
          comment: true
        }
      },
      process: {
        id: 'root',
        parentId: null,
        type: 'ROOT',
        name: '发起人',
        desc: '所有人',
        props: {
          assignedUser: []
        },
        children: {}
      }
    }
    return {
      activeSelect: 'processDesign',
      timer: null,
      validStep: 0,
      validVisible: false,
      validResult: {
        errs: []
      },
      validOptions: [
        {title: '审批流程', description: '', icon: '', status: ''},
        {title: '更多设置', description: '', icon: '', status: ''}
      ],
      validComponents: ['processDesign', 'advancedSetting'],
      state: {
        nodeMap: new Map(),
        isEdit: null,
        selectedNode: {},
        selectFormItem: null,
        design,
        runningList: [],
        noTakeList: [],
        endList: [],
        diagramMode: 'design',
        disableRoot: false
      },
      loading: false,
      committing: false
    }
  },
  computed: {
    formItems () {
      return this.designInfo.formItems || []
    },
    errTitle () {
      if (this.validResult.finished && !this.validResult.success) {
        return this.validResult.title + ` (${this.validResult.errs.length}项错误) 😥`
      }
      return this.validResult.title
    },
    validIcon () {
      if (!this.validResult.finished) {
        return 'el-icon-loading'
      } else if (this.validResult.success) {
        return 'el-icon-success is-success'
      } else {
        return 'el-icon-warning is-warning'
      }
    }
  },
  methods: {
    nodeSelected (node) {
      this.state.selectedNode = node
    },
    validateDesign () {
      this.validVisible = true
      this.validStep = 0
      this.showValiding()
      this.stopTimer()
      this.timer = setInterval(() => {
        this.validResult.errs = this.$refs[this.validComponents[this.validStep]].validate()
        if (Array.isArray(this.validResult.errs) && this.validResult.errs.length === 0) {
          this.validStep++
          if (this.validStep >= this.validOptions.length) {
            this.stopTimer()
            this.showValidFinish(true)
          }
        } else {
          this.stopTimer()
          this.validOptions[this.validStep].status = 'error'
          this.showValidFinish(false, this.getDefaultValidErr())
        }
      }, 300)
    },
    getDefaultValidErr () {
      switch (this.validStep) {
        case 0:
          return '请检查基础设置项'
        case 1:
          return '请检查审批表单相关设置'
        case 2:
          return '请检查审批流程，查看对应标注节点错误信息'
        case 3:
          return '请检查扩展设置'
        default:
          return '未知错误'
      }
    },
    showValidFinish (success, err) {
      this.validResult.success = success
      this.validResult.finished = true
      this.validResult.title = success ? '校验完成 😀' : '校验失败 '
      this.validResult.desc = success ? '设置项校验成功，是否提交？' : err
      this.validResult.action = success ? '提 交' : '去修改'
    },
    showValiding () {
      this.validResult = {
        errs: [],
        finished: false,
        success: false,
        title: '检查中...',
        action: '处理',
        desc: '正在检查设置项'
      }
      this.validStep = 0
      this.validOptions.forEach(op => {
        op.status = ''
        op.icon = ''
        op.description = ''
      })
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    doAfter () {
      if (this.validResult.success) {
        this.doPublish()
      } else {
        this.activeSelect = this.validComponents[this.validStep]
        this.validVisible = false
      }
    },
    doPublish () {
      this.$confirm('确认发布后流程立即生效，是否继续?', '提示', {
        confirmButtonText: '发布',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const design = this.state.design
        const config = {
          setting: JSON.stringify(design.setting),
          process: JSON.stringify(design.process)
        }
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/flow/configure/data/submitDesign',
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          params: {
            flowId: this.flowId
          },
          data: config
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.validVisible = false
                this.$nextTick(() => {
                  this.$emit('after-submit')
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      })
    },
    publish () {
      this.validateDesign()
    }
  },
  created () {
    const vm = this
    Object.defineProperty(this.state.design, 'formItems', {
      get () {
        return vm.formItems
      },
      enumerable: true
    })
  },
  beforeDestroy () {
    this.stopTimer()
  },
  watch: {
    designInfo: {
      handler (val) {
        if (val) {
          this.state.disableRoot = val.disableRoot
          const processJson = val.processJson
          if (processJson) {
            this.state.design.process = JSON.parse(processJson)
          }
          const settingJson = val.settingJson
          if (settingJson) {
            this.state.design.setting = JSON.parse(settingJson)
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@use "../../../../../styles/color" as *;

.flow-configure-data-design-main {
  position: relative;
  height: 100%;
  &>.menubar {
    position: absolute;
    height: 46px;
    right: 0;
    top: -46px;
    margin-top: -1px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    .el-button {
      padding: 7px 15px;
    }
  }
  &>.design-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    &>.header {
      flex: none;
      position: relative;
      background-color: #fff;
      text-align: center;
      &>.title {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 13px;
        font-weight: bold;
        padding: 4px 15px;
        i {
          margin-right: 2px;
          font-size: 14px;
          vertical-align: -1px;
        }
        .el-tag {
          margin-left: 4px;
        }
      }
      .el-radio-group {
        display: inline-flex;
        align-items: center;
        .el-radio-button {
          flex: auto;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
          outline: none!important;
          box-shadow: none!important;
          &.is-active {
            &:after {
              content: '';
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              height: 2px;
              background-color: var(--theme-color);
            }
            .el-radio-button__inner {
              color: var(--theme-color);
            }
          }
          &+.el-radio-button {
            margin-left: 40px;
          }
          .el-radio-button__inner {
            width: 100%;
            height: 100%;
            line-height: 46px;
            overflow: hidden;
            text-overflow: ellipsis;
            position: relative;
            color: #303133;
            font-size: 14px;
            padding: 0;
            background-color: transparent;
            border: none;
            box-shadow: none;
          }
        }
      }
    }
    &>.body {
      flex: auto;
      background-color: #f5f6f6;
      position: relative;
      &>.body-cont {
        position: absolute;
        inset: 0;
        .design-tabs {
          &.el-tabs {
            position: relative;
            height: 100%;
            &>.el-tabs__header {
              display: none;
            }
            &>.el-tabs__content {
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              .el-tab-pane {
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
}
.flow-configure-data-design-main-valid {
  padding: 30px 30px 15px;
  text-align: center;
  .result-wrap {
    margin-top: 8px;
    padding: 15px 0;
    .icon {
      i {
        font-size: 40px;
        &.is-success {
          color: $set-success-color;
        }
        &.is-warning {
          color: $set-warning-color;
        }
      }
    }
    .err-info {
      margin-top: 10px;
      max-height: 180px;
      overflow-y: auto;
      &>div {
        padding: 5px;
        margin: 2px auto;
        width: 240px;
        text-align: left;
        border-radius: 3px;
        background-color: rgb(242,242,242);
      }
      i {
        margin: 0 5px;
      }
    }
    .result {
      margin-top: 10px;
      .title {
        font-size: 15px;
        font-weight: bold;
      }
      .subtitle {
        margin-top: 10px;
      }
    }
    .footer {
      margin-top: 20px;
      .el-button {
        min-width: 100px;
      }
    }
  }
}
</style>
